import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRejectCollectionTriageClipRequest } from './reject-collection-triage-clip-request';
import type { IRejectCollectionTriageClipResponse } from './reject-collection-triage-clip-response';
import { rejectCollectionTriageClipResponseSchema } from './reject-collection-triage-clip-response';

export async function rejectCollectionTriageClipApi({
  collectionId,
  clipId,
  reason,
  alsoChallenge,
}: IRejectCollectionTriageClipRequest): Promise<
  IValidatedResponse<IRejectCollectionTriageClipResponse>
> {
  return postRequest<IRejectCollectionTriageClipResponse>({
    path: `/sys/collections/${collectionId}/triage/clips/${clipId}/reject`,
    body: { reason, alsoChallenge },
    schema: rejectCollectionTriageClipResponseSchema,
  });
}
